import styles from './FilterSelectorButtons.module.scss'
import { Button, Col, Row } from 'react-bootstrap'
import React from 'react'
import { useTranslation } from 'next-i18next'

interface Props {
  handleReset: () => void
  handleApply: () => void
}

const FilterSelectorButtons = ({ handleReset, handleApply }: Props) => {
  const { t } = useTranslation('common')
  return (
    <Row className={`${styles.root} mt-2`}>
      <Col xs={'auto'} className={'ms-auto'}>
        {/*<Button variant={'light'} size={'sm'} onClick={handleReset}>*/}
        {/*  {t('travelFilter.filterInput.reset')}*/}
        {/*</Button>*/}
        <Button variant={'signal'} size={'sm'} onClick={handleApply} className={`${styles.button} ms-2`}>
          {t('travelFilter.filterInput.apply')}
        </Button>
      </Col>
    </Row>
  )
}

export default FilterSelectorButtons
